import { styled } from '@mui/material/styles';

export const GeneralViewPortWrapper = styled('div')`
	height: 100%;
	min-height: calc(100vh);
	display: flex;
	flex-direction: column;
`;
